import PlaybookRootNode from './PlaybookRootNode';
import GlobalConfigNode from './GlobalConfigNode';
import EventSwitchNode from './EventSwitchNode';
import MappingNode from './MappingNode';
import EnrichmentNode from './EnrichmentNode';
import FilterNode from './FilterNode';
import InjectNode from './InjectNode'; // Import InjectNode
import DebugNode from './DebugNode';   // Import DebugNode

// Define the mapping for playbook node types
export const playbookNodeTypes = {
  'playbook-root': PlaybookRootNode,
  'global-config': GlobalConfigNode,
  'event-switch': EventSwitchNode, // Represents the eventSpecific block
  'mapping': MappingNode,         // Represents a block of mappings
  'enrichment': EnrichmentNode,   // Represents a block of enrichments
  'filter': FilterNode,           // Represents a block of filters
  'inject': InjectNode,           // Represents an injection point
  'debug': DebugNode,             // Represents a debug/logging point
  // Add other playbook/pipeline specific nodes here
};

// Placeholder for config boxes if needed for playbook nodes
export const playbookConfigBoxes = {
  // 'playbook-root': PlaybookRootConfigBox,
  // ...
};

// Placeholder for documentation if needed
export const playbookNodeDocumentation = {
  // 'playbook-root': "Documentation for root...",
  // ...
};
